import jwtAuthAxios from "../auth/jwtAuth";
import { getBEUrlForAdmin, setBackendDomain } from "./management";

/**
 * Authenticate device with Teya
 * @param {number} deviceId - Device ID
 * @param {number} customerId - Customer ID
 * @returns {Promise<Object>}
 */
export const teyaAuthCustomer = async (customerId, beDomain) => {
  jwtAuthAxios.defaults.baseURL = `${getBEUrlForAdmin(beDomain)}/`;
  // setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post(`/api/v1/teya/auth-customer`, {
    customerId,
  });
  return data;
};

/**
 * Disconnect device from Teya
 * @param {number} customerId - Customer ID
 * @returns {Promise<Object>}
 */
export const teyaDisconnectCustomer = async (customerId, beDomain) => {
  // setBackendDomain(jwtAuthAxios);
  jwtAuthAxios.defaults.baseURL = `${getBEUrlForAdmin(beDomain)}/`;
  const { data } = await jwtAuthAxios.put(`/api/v1/teya/disconnect-customer`, {
    customerId,
  });
  return data;
};

/**
 *
 * @param {*} customerId
 * @returns {Promise<Object>}
 */
export const getTeyaStores = async (customerId, beDomain) => {
  // setBackendDomain(jwtAuthAxios);
  jwtAuthAxios.defaults.baseURL = `${getBEUrlForAdmin(beDomain)}/`;
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get(`/api/v1/teya/stores/${customerId}`);
  return data?.message;
};

export const initTeyaStores = async (customerId, beDomain) => {
  // setBackendDomain(jwtAuthAxios);
  jwtAuthAxios.defaults.baseURL = `${getBEUrlForAdmin(beDomain)}/`;
  const { data } = await jwtAuthAxios.get(
    `/api/v1/teya/init-stores/${customerId}`
  );
  return data?.message?.stores;
};

export const renewTeyaToken = async (customerId, beDomain) => {
  // setBackendDomain(jwtAuthAxios);
  jwtAuthAxios.defaults.baseURL = `${getBEUrlForAdmin(beDomain)}/`;
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post(
    `/api/v1/teya/token/refresh/${customerId}`
  );
  return data?.message;
};
